export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_673_LOADING_METADATA_': 'Loading metadata...',
    '_675_LOADING_NAVIGATION_': 'Loading navigation...'
};
